import { Badge } from '../../../../../../components/atoms/badge/badge';
import {
  TIPO_PRODUTO_LABEL,
  TipoProduto,
} from '../../../../../../types/cliente-produto';

interface Props {
  tipo: TipoProduto | null;
  descricao?: string | null;
}

export const ProdutoTipoBadge = ({ tipo, descricao }: Props) => {
  if (tipo == null) {
    return <Badge variant="neutral">—</Badge>;
  }
  return (
    <Badge variant="info">
      {descricao ?? TIPO_PRODUTO_LABEL[tipo] ?? `Tipo ${tipo}`}
    </Badge>
  );
};
